import { render, staticRenderFns } from "./NoDealModal.vue.vue?vue&type=template&id=0560c988"
import script from "./NoDealModal.vue.vue?vue&type=script&lang=js"
export * from "./NoDealModal.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports